// extracted by mini-css-extract-plugin
module.exports = {"SectionHeading":"SectionHeading_SectionHeading__3kzkV"};